module.exports = __webpack_public_path__ + "static/img/course2.90bdefba.png";